import { getWrapperClassName } from '@/components/design-system/utils'
import React, { ReactNode } from 'react'

type Size = 'h1' | 'h2' | 'h3'
type Props = Readonly<{
  className?: string
  size: Size
  children: ReactNode
}>

export const TLTitle = (props: Props) => {
  const h1CSS = 'text-6xl text-darkblue font-semibold max-xl:text-5xl'
  const h2CSS = 'text-2xl font-bold max-xl:text-xl'
  const h3CSS = 'text-xl max-xl:text-lg'

  return (
      <>
        { props.size === 'h1' &&
            <h1 className={ getWrapperClassName(props.className, h1CSS) }>{ props.children }</h1>
        }
        { props.size === 'h2' &&
            <h2 className={ getWrapperClassName(props.className, h2CSS) }>{ props.children }</h2>
        }
        { props.size === 'h3' &&
            <h3 className={ getWrapperClassName(props.className, h3CSS) }>{ props.children }</h3>
        }
      </>
  )
}

TLTitle.defaultProps = {
  className: ''
}
